(function (angular, app) {
   "use strict";

   angular.module(app.modules.common.name)
      .factory(app.modules.common.services.storage, StorageFactory);
   
   StorageFactory.$inject = ["$window"];
   
   function StorageFactory($window) {
      
      var _keys = {
         app: {
            version: "app.version"
            , lastMemberId: "app.lastMemberId"
         }
         , member: {
            username: "member.username"
            , id: "member.individualid"
            , bearertoken: "member.bearertoken"
            , refreshtoken: "member.refreshtoken"
            , firstname : "member.firstname"
            , lastname: "member.lastname"
            , password : "member.password"
            , prefs: {
               course : {
                  teeId : "member.prefs.teeId"
                  , courseId : "member.prefs.courseId"
                  , courseObj : "member.prefs.courseObj"
               }
               , group : {
                  groupId : "member.prefs.groupId"
                  , groupObj : "member.prefs.groupObj"
               }
               , isHoleByHole: "member.prefs.isHoleByHole"
               , isStatistics: "member.prefs.isStatistics"
               , isTraditional: "member.prefs.isTraditional"
               , holesPlayed: "member.prefs.holesPlayed"
               , stats: {
                  putts: "member.prefs.stats.putts"
                  , penalties: "member.prefs.stats.penalties"
                  , club: "member.prefs.stats.club"
                  , drive: "member.prefs.stats.drive"
                  , fir: "member.prefs.stats.fir"
                  , updown: "member.prefs.stats.updown"
                  , sandie: "member.prefs.stats.sandie"
                  , puttlength: "member.prefs.stats.puttlength"

               }
            }
         }
         , scoring: {
            inProgress: {
               isCurrent : "scores.inprogress.iscurrent"
               , data: "scores.inprogress"
            }
            , recent: {
               isCurrent: "scores.top30scores.iscurrent"
               , data: "scores.top30scores"
            }
            , archive: {
               isCurrent: "scores.archive.iscurrent"
               , data: "scores.archive"
            }
            , revision: {
               isCurrent: "revision.history.iscurrent"
               , data : "revision.history"
            }
         }
         , clubs: {
            my: {
               isCurrent: "clubs.myclubs.iscurrent"
               , data : "clubs.myclubs"
            }
            , primary : "clubs.primary"
         }
         , groups: {
            my: {
               isCurrent: "group.mygroups.iscurrent"
               , data : "group.mygroups"
            }
            , organizer: {
               isCurrent: "group.organizer.iscurrent"
               , data: "group.organizer"
            }
            , allmygroups: {
                isCurrent: "group.allmygroups.iscurrent"
               , data: "group.allmygroups"
            }
             , nearme: {
                 isCurrent: "group.nearme.iscurrent"
               , data: "group.nearme"
             }
         }
         , outings: {
             organizer: {
                 isCurrent: "outing.organizer.iscurrent"
                , data: "outing.organizer"
             }
            , player: {
                isCurrent: "outing.player.iscurrent"
               , data: "outing.player"
            }
            , playerOrOrganizer: {
                isCurrent: "outing.playerOrOrganizer.iscurrent"
               , data: "outing.playerOrOrganizer"
            }
            , inprogress: "outing.scoresInProgress"
         }
         , courses: {
            my: {
               isCurrent: "courses.mycourses.iscurrent"
               , data: "courses.mycourses"
            }
            , location: {
               isCurrent: "courses.bylocation.iscurrent"
               , data: "courses.bylocation"
            }
         }
         , members: {
            my: {
               isCurrent: "members.myfriends.iscurrent"
               , data : "members.myfriends"
            }
            , partners: {
               isCurrent: "members.partners.iscurrent"
               , data: "members.partners"
            }
         }
         , invitations: {
            my: {
               isCurrent: "invitations.myinvitations.iscurrent"
               , data : "invitations.myinvitations"
            }
         }
      }
      
      
      //##//--------------------------------------- 
      
       var _get = function (key) {
           if (key) {
               key = key.toLowerCase();
               return $window.localStorage[key] || null;
           } else {
               return null;
           }
      },
      _set = function (key, value) {
         key = key.toLowerCase();
         var v = value;
         if( (typeof value === "object") && (value !== null) ){
            v = JSON.stringify(value);
         }
         
          // gap 11.23.2016 - "if (v)" will treat 0 as false"
         if (v != null){
            $window.localStorage[key] = v;
         }else{
            $window.localStorage.removeItem(key);
         }
      };
      
      //##//--------------------------------------- 

      var service = {
         get: _get
         , set: _set
         , keys : _keys         
      };
      
      return service;
   }
   
}(angular, app));
